import { Component, inject } from '@angular/core';
import { InputComponent } from '@shared/components/input/input.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../services/authentication.service';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { MessageToasterComponent, ToasterType } from '@shared/components/message-toaster/message-toaster.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { PASTE_CODE_REGEX, VALIDATION_CODE_REGEX } from '../validators.const';
import { MatButton } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
  selector: 'app-verification-modal',
  imports: [
    InputComponent,
    ReactiveFormsModule,
    TranslateModule,
    MatButton,
    MatDialogClose,
  ],
  templateUrl: './verification-modal.component.html',
  styleUrl: './verification-modal.component.scss',
})

export class VerificationModalComponent {
  verificationCode = new FormControl('', [Validators.required, Validators.minLength(6)]);
  dialogRef = inject<DialogRef<string>>(DialogRef<string>);
  data = inject(DIALOG_DATA);
  snackBar = inject(MatSnackBar);
  displayTimer: any;
  tryAgainDisabled = false;

  protected readonly ButtonTypes = BUTTON_TYPES;
  protected readonly VALIDATION_CODE_REGEX = VALIDATION_CODE_REGEX;
  protected readonly PASTE_CODE_REGEX = PASTE_CODE_REGEX;

  constructor(private authService: AuthenticationService) {
  }


  verify() {
    let code = this.verificationCode.value as string;
    this.authService.confirmSignUp(this.data.email, code)
      .then(() => {
        this.dialogRef.close(code);
      }, error => {
        this.snackBar.openFromComponent(MessageToasterComponent, {
          data: {
            message: error.message,
            title: '',
          },
          panelClass: ToasterType.ERROR,
          duration: 5000,
        });
      });
  }

  tryAgain() {
    this.authService.resendCode(this.data.email);
    this.tryAgainDisabled = true;
    this.timer(3);
  }

  closeModal() {
    this.dialogRef.close();
  }

  timer(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;

    const prefix = minute < 10 ? '0' : '';

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.displayTimer = `(${prefix}${Math.floor(seconds / 60)}:${textSec})`;

      if (seconds == 0) {
        this.tryAgainDisabled = false;
        clearInterval(timer);
      }
    }, 1000);
  }
}
